@if (medicalDataModelled) {
  <div class="medical-data-container">
    <div class="data-container">
      <nz-table nzTemplateMode>
        <thead>
          <tr>
            <th class="empty-th" nzWidth="30%"></th>
            <!--<th>
              {{ 'medicalData.first_misuration' | translate }}
            </th>-->
            <th class="misuration" nzWidth="70%">{{ 'medicalData.second_misuration' | translate }}</th>
            <!--<th>{{ 'medicalData.trend' | translate }}</th>-->
          </tr>
        </thead>
        <tbody>
          @for (id of idData; track id) {
            <tr>
              <td>
                <p>{{ 'medicalData.' + id | translate }}</p>
                  <a (click)="addData(id)"> {{ 'medicalData.add' | translate }} </a>
              </td>
              <!--<td class="centered-cell bold">
                  {{ medicalDataModelled.firstMeasurement[id].value | translate}} @if (id !== 'isSmoker') { {{ medicalDataModelled.firstMeasurement[id].measure_unit }} }
                <span>{{ medicalDataModelled.firstMeasurement.lastTimeModified | date: 'dd/MM/yyyy' }}</span>
              </td>-->
             <!--  @if (id !== 'bloodGroup') { -->
                <td class="centered-cell bold flex-end">
                  {{ medicalDataModelled.lastMeasurement?.[id]?.value | translate}} @if (id !== 'isSmoker') { {{ medicalDataModelled.firstMeasurement?.[id]?.measure_unit }}  }
                  <!--<span>{{ medicalDataModelled.lastMeasurement.lastTimeModified | date: 'dd/MM/yyyy' }}</span>-->
                </td>
                <!--<td class="centered-cell">
                  @if (id !== 'isSmoker') {
                    <app-trend [valuesToCompare]="{ first: +medicalDataModelled.firstMeasurement[id].value, second: +medicalDataModelled.lastMeasurement[id].value }"></app-trend>
                  }
                </td>-->
             <!-- }  @else {
                <td colspan="1"></td>
              } -->
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </div>
}
